/* build 2026-09-09-serve-current — version bump to force fresh asset ?v= on CDN */
/* =====================================================================
   THETIS — front-end behaviour
   Cart drawer + AJAX cart, search overlay + predictive search,
   product quantity stepper, and the laser-engraving customizer.
   No framework; progressive-enhancement over server-rendered Liquid.
   ===================================================================== */
(function () {
  'use strict';

  var Thetis = window.Thetis || {};
  var routes = Thetis.routes || {};

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    // Shopify money_format may contain {{amount}} — good enough for the drawer.
    var amount = (cents / 100).toFixed(2);
    var fmt = Thetis.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  /* ---------- drawers ---------- */
  function openDrawer(name) {
    var drawer = $('[data-thetis-drawer="' + name + '"]');
    var overlay = $('[data-thetis-overlay="' + name + '"]');
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    var focusable = drawer.querySelector('input, button');
    if (focusable && name === 'search') setTimeout(function () { focusable.focus(); }, 250);
  }
  function closeDrawer(name) {
    var drawer = $('[data-thetis-drawer="' + name + '"]');
    var overlay = $('[data-thetis-overlay="' + name + '"]');
    if (drawer) { drawer.removeAttribute('data-open'); drawer.setAttribute('aria-hidden', 'true'); }
    if (overlay) overlay.removeAttribute('data-open');
    document.body.style.overflow = '';
  }
  function closeAll() { closeDrawer('cart'); closeDrawer('search'); closeDrawer('mobile-nav'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-thetis-cart-open]')) { e.preventDefault(); openDrawer('cart'); }
    if (e.target.closest('[data-thetis-cart-close]')) { closeDrawer('cart'); }
    if (e.target.closest('[data-thetis-search-open]')) { e.preventDefault(); openDrawer('search'); }
    if (e.target.closest('[data-thetis-search-close]')) { closeDrawer('search'); }
    if (e.target.closest('[data-mobile-open]')) { e.preventDefault(); openDrawer('mobile-nav'); }
    if (e.target.closest('[data-mobile-close]')) { closeDrawer('mobile-nav'); }
    if (e.target.matches('.thetis-overlay')) { closeAll(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- cart: swap rendered section into the DOM ---------- */
  function applyCartSection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    ['[data-cart-body]', '[data-cart-foot]'].forEach(function (sel) {
      var next = doc.querySelector(sel), cur = $(sel);
      if (next && cur) cur.innerHTML = next.innerHTML;
    });
    var nextFoot = doc.querySelector('[data-cart-foot]'), curFoot = $('[data-cart-foot]');
    if (nextFoot && curFoot) { if (nextFoot.hasAttribute('hidden')) curFoot.setAttribute('hidden', ''); else curFoot.removeAttribute('hidden'); }
  }

  function refreshCartCount(count) {
    var el = $('[data-cart-count]');
    if (!el) return;
    el.textContent = count;
    if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
  }

  function cartRequest(url, body, isJson) {
    var opts = { method: 'POST', headers: {} };
    if (isJson) { opts.headers['Content-Type'] = 'application/json'; opts.headers['Accept'] = 'application/json'; opts.body = JSON.stringify(body); }
    else { opts.body = body; }
    return fetch(url, opts).then(function (r) { return r.json(); });
  }

  /* add to cart (product forms) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-thetis-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    // Collect the form into an items[] payload so an engraving add-on can ride along.
    var fields = {}, props = {};
    new FormData(form).forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) { if (v) props[m[1]] = v; } else { fields[k] = v; }
    });
    var qty = parseInt(fields.quantity, 10) || 1;
    var items = [{ id: fields.id, quantity: qty, properties: props }];
    // Engraving ($9.99) is added on its own via the "Add to Cart — $9.99" button in the Personalize section.
    cartRequest(routes.cart_add_url + '.js', {
      items: items, sections: 'cart-drawer', sections_url: window.location.pathname
    }, true).then(function (data) {
      if (data && data.sections) applyCartSection(data.sections['cart-drawer']);
      return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      if (cart) refreshCartCount(cart.item_count);
      openDrawer('cart');
    }).catch(function () {}).then(function () {
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; }
    });
  });

  /* engraving add-on: "Add to Cart — $9.99" adds the Laser Engraving product with the front/back inscription */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-engrave-addcart]');
    if (!addBtn) return;
    var eroot = addBtn.closest('[data-engrave-root]');
    var isFree = !!(eroot && eroot.hasAttribute('data-engrave-free'));
    if (!isFree && !Thetis.engravingVariantId) { alert('Engraving is temporarily unavailable.'); return; }
    var props = {};
    var TYPE_LABEL = { name: 'Name', sentence: 'Message', zodiac: 'Zodiac sign', photo: 'Custom artwork' };
    $all('[data-engrave-side]', eroot).forEach(function (side) {
      var name = side.getAttribute('data-engrave-side'); // Front / Back
      var t = side.querySelector('[data-engrave-type]'), tx = side.querySelector('[data-engrave-text]'), fn = side.querySelector('[data-engrave-font]');
      if (!t || !t.value) return;
      var type = t.value, text = (tx && tx.value) || '', fontCss = (fn && fn.value) || '';
      var fontName = fontCss ? fontCss.split(',')[0].replace(/['"]/g, '').trim() : ''; // "'Great Vibes', cursive" -> "Great Vibes"
      var value = type === 'photo' ? text.replace(/^Custom artwork:\s*/i, '') : text;
      // human-readable cart labels, e.g. "Back side — Name: Eliza" / "Back side font: Great Vibes"
      props[name + ' side — ' + (TYPE_LABEL[type] || 'Personalization')] = value || type;
      if (fontName && (type === 'name' || type === 'sentence')) props[name + ' side font'] = fontName;
    });
    if (!Object.keys(props).length) { alert('Choose a name, sentence, or zodiac icon for the front or back side first.'); return; }
    // Global engraving options: colour (Gold / White-Clear) + floral border design.
    var colorInp = eroot.querySelector('[data-engrave-color]');
    props['Engraving colour'] = (colorInp && colorInp.value === 'white') ? 'White (Clear)' : 'Gold';
    var floralInp = eroot.querySelector('[data-engrave-floral]');
    if (floralInp && floralInp.value) props['Floral border'] = 'Design ' + floralInp.value;
    // Free mode (For The One): attach the engraving as line-item properties on the base bottle form
    // (recorded for fulfillment, no separate paid product) instead of adding the $9.99 add-on.
    if (isFree) {
      var tform = document.querySelector(eroot.getAttribute('data-engrave-form') || '[data-thetis-product-form]');
      if (!tform) { alert('Please choose your base and note above first.'); return; }
      $all('input[data-engrave-prop]', tform).forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      Object.keys(props).forEach(function (k) {
        var inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = 'properties[' + k + ']'; inp.value = props[k];
        inp.setAttribute('data-engrave-prop', ''); tform.appendChild(inp);
      });
      var okmsg = eroot.querySelector('[data-engrave-added]'); if (okmsg) okmsg.hidden = false;
      addBtn.textContent = '✓ Engraving set';
      return;
    }
    addBtn.disabled = true; var lbl = addBtn.textContent; addBtn.textContent = 'Adding…';
    cartRequest(routes.cart_add_url + '.js', {
      items: [{ id: Thetis.engravingVariantId, quantity: 1, properties: props }], sections: 'cart-drawer', sections_url: window.location.pathname
    }, true).then(function (data) {
      if (data && data.sections) applyCartSection(data.sections['cart-drawer']);
      return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      if (cart) refreshCartCount(cart.item_count);
      var msg = eroot.querySelector('[data-engrave-added]'); if (msg) msg.hidden = false;
      openDrawer('cart');
    }).catch(function () {}).then(function () {
      addBtn.disabled = false; addBtn.textContent = lbl;
    });
  });

  /* cap engraving (design 2026-10): "Engraving the Cap" — option grid + preview thumbs + add the $0 add-on */
  document.addEventListener('click', function (e) {
    // option select
    var opt = e.target.closest('[data-cap-opt]');
    if (opt) {
      var croot = opt.closest('[data-cap-root]'); if (!croot) return;
      $all('[data-cap-opt]', croot).forEach(function (b) { b.style.background = '#B08D57'; b.style.color = '#FAF7F1'; b.style.borderColor = 'transparent'; b.removeAttribute('data-cap-selected'); });
      opt.style.background = '#6E5433'; opt.style.color = '#FAF7F1'; opt.style.borderColor = '#2b2620'; opt.setAttribute('data-cap-selected', '');
      var wrap = croot.querySelector('[data-cap-inputwrap]');
      if (opt.hasAttribute('data-cap-input')) {
        wrap.hidden = false;
        croot.querySelector('[data-cap-inputlbl]').textContent = opt.getAttribute('data-cap-lbl') || 'Enter your text';
        var inp = croot.querySelector('[data-cap-text]'); var max = opt.getAttribute('data-cap-max') || 10;
        inp.placeholder = opt.getAttribute('data-cap-ph') || ''; inp.setAttribute('maxlength', max); inp.value = '';
        croot.querySelector('[data-cap-count]').textContent = '0 / ' + max + ' characters';
      } else { wrap.hidden = true; }
      return;
    }
    // preview thumbnail select
    var thumb = e.target.closest('[data-cap-thumb]');
    if (thumb) {
      var croot2 = thumb.closest('[data-cap-root]'); if (!croot2) return;
      croot2.querySelector('[data-cap-main]').src = thumb.getAttribute('data-cap-thumb');
      $all('[data-cap-thumb]', croot2).forEach(function (t) { t.style.borderColor = 'transparent'; });
      thumb.style.borderColor = '#8C6D3F';
      return;
    }
    // add cap engraving to cart
    var capAdd = e.target.closest('[data-cap-addcart]');
    if (capAdd) {
      var root = capAdd.closest('[data-cap-root]'); if (!root) return;
      if (!Thetis.engravingVariantId) { alert('Engraving is temporarily unavailable.'); return; }
      var sel = root.querySelector('[data-cap-opt][data-cap-selected]');
      if (!sel) { alert('Choose a cap engraving option first.'); return; }
      var label = sel.textContent.trim(), value = label;
      if (sel.hasAttribute('data-cap-input')) {
        var txt = (root.querySelector('[data-cap-text]').value || '').trim();
        if (!txt) { alert('Enter your text for the cap engraving first.'); return; }
        value = '“' + txt + '” (' + label + ')';
      }
      var props = { 'Cap engraving': value };
      capAdd.disabled = true; var clbl = capAdd.textContent; capAdd.textContent = 'Adding…';
      cartRequest(routes.cart_add_url + '.js', {
        items: [{ id: Thetis.engravingVariantId, quantity: 1, properties: props }], sections: 'cart-drawer', sections_url: window.location.pathname
      }, true).then(function (data) {
        if (data && data.sections) applyCartSection(data.sections['cart-drawer']);
        return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        if (cart) refreshCartCount(cart.item_count);
        openDrawer('cart');
      }).catch(function () {}).then(function () {
        capAdd.disabled = false; capAdd.textContent = clbl;
      });
    }
  });
  // live char count for cap text
  document.addEventListener('input', function (e) {
    var inp = e.target.closest('[data-cap-text]'); if (!inp) return;
    var root = inp.closest('[data-cap-root]'); var max = inp.getAttribute('maxlength') || 10;
    var c = root.querySelector('[data-cap-count]'); if (c) c.textContent = inp.value.length + ' / ' + max + ' characters';
  });

  /* qty change + remove inside the drawer */
  function changeLine(key, quantity) {
    cartRequest(routes.cart_change_url + '.js', { id: key, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname }, true)
      .then(function (data) {
        applyCartSection(data.sections && data.sections['cart-drawer']);
        refreshCartCount(data.item_count);
      });
  }
  document.addEventListener('click', function (e) {
    var line = e.target.closest('[data-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qtyEl = line.querySelector('[data-qty-value]');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.closest('[data-qty-inc]')) changeLine(key, qty + 1);
    else if (e.target.closest('[data-qty-dec]')) changeLine(key, Math.max(0, qty - 1));
    else if (e.target.closest('[data-line-remove]')) changeLine(key, 0);
  });

  /* ---------- search: client-side over the Liquid-rendered index (matches ANY content, correct prices) ---------- */
  var searchIndex = null;
  function getSearchIndex() {
    if (searchIndex) return searchIndex;
    var el = document.querySelector('[data-thetis-search-index]');
    try { searchIndex = el ? JSON.parse(el.textContent) : []; } catch (e) { searchIndex = []; }
    return searchIndex;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-thetis-search-input]');
    if (!input) return;
    var results = $('[data-thetis-search-results]');
    if (!results) return;
    var raw = input.value.trim();
    if (!raw) { results.innerHTML = ''; return; }
    var terms = raw.toLowerCase().split(/\s+/).filter(Boolean);
    var matches = getSearchIndex().filter(function (p) {
      return terms.every(function (t) { return p.s.indexOf(t) !== -1; });
    });
    if (!matches.length) {
      results.innerHTML = '<div class="search-empty">No scents found for &ldquo;' + escapeHtml(raw) + '&rdquo;</div>';
      return;
    }
    results.innerHTML = matches.slice(0, 24).map(function (p) {
      var img = p.i ? '<img src="' + p.i + '" width="44" height="44" style="border-radius:4px;object-fit:contain;background:#fff" alt="">' : '';
      var sub = p.b ? '<span style="font-size:12px;color:var(--thetis-gold);display:block">Inspired by ' + escapeHtml(p.b) + '</span>' : '';
      return '<a class="search-result" href="' + p.u + '"><span style="display:flex;align-items:center;gap:12px">' + img +
             '<span><span style="font-family:var(--thetis-serif);font-size:17px;display:block">' + escapeHtml(p.t) + '</span>' + sub + '</span></span>' +
             '<span style="font-size:13px;color:var(--thetis-muted);white-space:nowrap">' + escapeHtml(p.p) + '</span></a>';
    }).join('');
  });

  /* ---------- product: gallery thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var main = $('[data-gallery-main]');
    if (main) main.src = thumb.getAttribute('data-gallery-thumb');
  });

  /* ---------- product: quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty-stepper]');
    var field = wrap && wrap.querySelector('[data-qty-input]');
    if (!field) return;
    var val = parseInt(field.value, 10) || 1;
    val = step.getAttribute('data-qty-step') === 'inc' ? val + 1 : Math.max(1, val - 1);
    field.value = val;
    var out = wrap.querySelector('[data-qty-out]'); if (out) out.textContent = val;
  });

  /* ---------- engraving customizer (design: two pills + two images open ONE shared editor) ---------- */
  function initEngravingRoot(root) {
    var defaultFont = root.getAttribute('data-default-font') || "'Jost', sans-serif";
    // Engraving colour (gold / white-clear) — drives the preview text colour + example images.
    var engColor = 'gold';
    function colorHex() { return engColor === 'white' ? '#FFFFFF' : '#D9B25A'; }
    var editor    = root.querySelector('[data-engrave-editor]');
    var sideName  = root.querySelector('[data-engrave-sidename]');
    var opts      = $all('[data-engrave-option]', root);
    var textWrap  = root.querySelector('[data-engrave-textwrap]');
    var textInput = root.querySelector('[data-engrave-textinput]');
    var wordCount = root.querySelector('[data-engrave-wordcount]');
    var zodiacWrap= root.querySelector('[data-engrave-zodiacwrap]');
    var photoWrap = root.querySelector('[data-engrave-photowrap]');
    var photoInput= root.querySelector('[data-engrave-photo]');
    var fontWrap  = root.querySelector('[data-engrave-fontwrap]');
    var zoom      = root.querySelector('[data-engrave-zoom]');
    var zoomImg   = root.querySelector('[data-engrave-zoomimg]');
    var zoomBox   = root.querySelector('[data-engrave-zoombox]');
    var zoomText  = root.querySelector('[data-engrave-zoomtext]');
    var zoomIcon  = root.querySelector('[data-engrave-zoomicon]');
    var zoomSrc   = { Front: root.getAttribute('data-zoom-front') || '', Back: root.getAttribute('data-zoom-back') || '' };
    // overlay box coords per side, from the design's zoomBoxStyle
    var ZBOX      = { Front: { left: '35.3%', width: '30.1%', top: '64.5%', height: '10.3%' },
                      Back:  { left: '35%',   width: '33.1%', top: '37.8%', height: '42.2%' } };
    // Mobile: reorder the stacked editor so the flow reads top-to-bottom the way a shopper
    // works — pick a side, SEE the live bottle preview, choose your options, then Add to Cart.
    // (On desktop the 2-column layout is untouched.) The preview + button move into the left
    // column, right around the controls, instead of landing far below them.
    if (editor && editor.parentNode && window.matchMedia('(max-width: 820px)').matches) {
      try {
        if (zoom) editor.parentNode.insertBefore(zoom, editor);        // preview ABOVE the controls
        var addBtnEl = root.querySelector('[data-engrave-addcart]');
        var addedEl  = root.querySelector('[data-engrave-added]');
        if (addBtnEl) editor.parentNode.appendChild(addBtnEl);         // Add to Cart right AFTER the controls
        if (addedEl)  editor.parentNode.appendChild(addedEl);
      } catch (e) {}
    }
    // Google Fonts load lazily (display=swap) and the font grid starts inside a closed (display:none)
    // editor, so the preview fonts otherwise never fetch — selecting a font wouldn't change the inscription.
    // Force-load every option's font up front so picking one actually re-renders the name/sentence.
    if (document.fonts && document.fonts.load) {
      $all('[data-font]', root).forEach(function (b) {
        try { document.fonts.load('16px ' + b.getAttribute('data-font')).then(function () { if (open) renderZoom(open, state[open]); }); } catch (e) {}
      });
    }
    // Render the preview: the selected side's bottle close-up with the inscription (multiline) overlaid where it engraves.
    function renderZoom(side, s) {
      if (!zoom) return;
      if (zoomImg) { var src = zoomSrc[side] || ''; if (src && zoomImg.getAttribute('src') !== src) zoomImg.setAttribute('src', src); }
      if (!zoomBox || !zoomText) return;
      var isZod = (s.type === 'zodiac' && s.zIcon);
      var txt = isText(s) ? (s.text || '') : '';
      if (!isZod && !txt) { zoomBox.hidden = true; return; }
      var b = ZBOX[side] || ZBOX.Front;
      zoomBox.hidden = false;
      zoomBox.style.left = b.left; zoomBox.style.width = b.width; zoomBox.style.top = b.top; zoomBox.style.height = b.height;
      if (isZod) {
        if (zoomText) zoomText.hidden = true;
        if (zoomIcon) {
          zoomIcon.hidden = false;
          // size the icon to the engraving box like the design (small on the front strip, larger on the back panel)
          var wrapW = zoom.getBoundingClientRect().width || 313;
          var aspect = (side === 'Front') ? (2000 / 1545) : (1182 / 912); // native ratio of the engrave-area image
          var bw = wrapW * (parseFloat(b.width) / 100), bh = (wrapW * aspect) * (parseFloat(b.height) / 100);
          var px = Math.max(16, Math.min(bw * 0.62, bh * 0.8 - 9 * 1.3 - 5));
          var zi = zoomIcon.querySelector('[data-engrave-zicon]'), zl = zoomIcon.querySelector('[data-engrave-zlabel]');
          if (zi) { zi.style.width = px + 'px'; zi.style.height = px + 'px'; zi.style.backgroundImage = 'url(' + s.zIcon + ')'; }
          if (zl) { zl.textContent = s.zLabel || ''; zl.style.fontFamily = s.font; }  // design: sign name uses the selected font
        }
      } else {
        if (zoomIcon) zoomIcon.hidden = true;
        if (zoomText) {
          zoomText.hidden = false;
          zoomText.textContent = txt;
          zoomText.style.fontFamily = s.font;
          zoomText.style.fontSize = (s.type === 'sentence' ? 13 : 15) + 'px';
          zoomText.style.color = colorHex();
        }
      }
    }
    var addBtn    = root.querySelector('[data-engrave-addcart]');
    var state = {
      Front: { type: '', text: '', font: defaultFont, zKey: '', zIcon: '', zLabel: '' },
      Back:  { type: '', text: '', font: defaultFont, zKey: '', zIcon: '', zLabel: '' }
    };
    var open = null;
    function limit(side) { return side === 'Front' ? 6 : 32; }
    function wordsOf(t) { return t ? t.split(/\s+/).filter(Boolean).length : 0; }
    function holder(side) { return root.querySelector('[data-engrave-side="' + side + '"]'); }
    function isText(s) { return s.type === 'name' || s.type === 'sentence'; }
    function hasValue(s) {
      if (s.type === 'name' || s.type === 'sentence' || s.type === 'photo') return !!s.text;
      if (s.type === 'zodiac') return !!s.zKey;
      return false;
    }
    function previewOf(s) {
      if ((s.type === 'name' || s.type === 'sentence' || s.type === 'photo') && s.text) return s.text;
      return '';
    }
    function syncHolder(side) {
      var s = state[side], h = holder(side); if (!h) return;
      var ty = h.querySelector('[data-engrave-type]'), tx = h.querySelector('[data-engrave-text]'), fn = h.querySelector('[data-engrave-font]');
      var ok = hasValue(s);
      if (ty) ty.value = ok ? s.type : '';
      if (tx) tx.value = ok ? (s.type === 'zodiac' ? s.zLabel : s.text) : '';
      if (fn) fn.value = (ok && isText(s)) ? s.font : '';
    }
    function syncOverlay(side) {
      var el = root.querySelector('[data-engrave-overlay="' + side + '"]'); if (!el) return;
      var s = state[side], t = previewOf(s);
      el.textContent = t; el.style.fontFamily = isText(s) ? s.font : ''; el.style.color = colorHex(); el.hidden = !t;
    }
    function render() {
      if (!open) { if (editor) editor.hidden = true; if (zoom) zoom.hidden = true; if (addBtn) addBtn.hidden = true; return; }
      var s = state[open];
      if (editor) editor.hidden = false;
      if (addBtn) addBtn.hidden = false;
      if (sideName) sideName.textContent = open;
      opts.forEach(function (b) {
        var backOnly = b.hasAttribute('data-back-only');
        b.hidden = backOnly && open !== 'Back';
        b.setAttribute('aria-pressed', b.getAttribute('data-engrave-option') === s.type);
      });
      if (textWrap)   textWrap.hidden   = !isText(s);
      if (zodiacWrap) zodiacWrap.hidden = s.type !== 'zodiac';
      if (photoWrap)  photoWrap.hidden  = s.type !== 'photo';
      if (fontWrap)   fontWrap.hidden   = (!s.type || s.type === 'photo');
      if (textInput) {
        textInput.value = s.text || '';
        textInput.placeholder = s.type === 'sentence' ? ('A short message, up to ' + limit(open) + ' words') : 'Your name';
      }
      if (wordCount) {
        if (s.type === 'sentence') { wordCount.hidden = false; wordCount.textContent = wordsOf(s.text) + ' / ' + limit(open) + ' words'; }
        else wordCount.hidden = true;
      }
      $all('[data-zodiac]', root).forEach(function (b) { b.setAttribute('aria-pressed', !!s.zKey && b.getAttribute('data-key') === s.zKey); });
      $all('[data-font]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-font') === s.font); });
      if (zoom) { zoom.hidden = false; renderZoom(open, s); }
      $all('[data-engrave-open]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-engrave-open') === open); });
    }
    function commit() { syncHolder(open); syncOverlay(open); render(); }

    $all('[data-engrave-open]', root).forEach(function (btn) {
      btn.addEventListener('click', function () { open = btn.getAttribute('data-engrave-open'); render(); });
    });
    opts.forEach(function (b) {
      b.addEventListener('click', function () { if (!open) return; state[open].type = b.getAttribute('data-engrave-option'); commit(); });
    });
    if (textInput) textInput.addEventListener('input', function () {
      if (!open) return; var s = state[open]; var val = textInput.value;
      if (s.type === 'sentence') {
        var w = val.split(/\s+/).filter(Boolean);
        if (w.length > limit(open)) { w = w.slice(0, limit(open)); val = w.join(' '); textInput.value = val; }
        if (wordCount) wordCount.textContent = w.length + ' / ' + limit(open) + ' words';
      }
      s.text = val; syncHolder(open); syncOverlay(open);
      renderZoom(open, s);
    });
    if (photoInput) photoInput.addEventListener('change', function () {
      if (!open) return; var f = photoInput.files && photoInput.files[0];
      state[open].text = f ? ('Custom artwork: ' + f.name) : ''; commit();
    });

    /* ---- Design layout: price tiers + two labeled text boxes + shared font ---- */
    var tierBtns = $all('[data-engrave-tier]', root);
    var frontBox = root.querySelector('[data-engrave-sidebox="Front"]');
    var backBox  = root.querySelector('[data-engrave-sidebox="Back"]');
    function clearSide(side) { var f = state[side].font; state[side] = { type: '', text: '', font: f, zKey: '', zIcon: '', zLabel: '' }; var ta = root.querySelector('[data-engrave-directtext="' + side + '"]'); if (ta) ta.value = ''; var cc = root.querySelector('[data-engrave-charcount="' + side + '"]'); if (cc) cc.textContent = '0'; $all('[data-zodiac-side="' + side + '"]', root).forEach(function (z) { z.setAttribute('aria-pressed', 'false'); }); syncHolder(side); syncOverlay(side); }
    function setTier(t) {
      tierBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-engrave-tier') === t); });
      var showFront = (t === 'Front' || t === 'Both'), showBack = (t === 'Back' || t === 'Both');
      if (frontBox) frontBox.hidden = !showFront;
      if (backBox) backBox.hidden = !showBack;
      if (!showFront) clearSide('Front');
      if (!showBack) clearSide('Back');
      open = showFront ? 'Front' : 'Back';
      render();
    }
    tierBtns.forEach(function (b) { b.addEventListener('click', function () { setTier(b.getAttribute('data-engrave-tier')); }); });

    // direct text boxes (one per side)
    $all('[data-engrave-directtext]', root).forEach(function (ta) {
      var side = ta.getAttribute('data-engrave-directtext');
      var cc = root.querySelector('[data-engrave-charcount="' + side + '"]');
      ta.addEventListener('focus', function () { open = side; render(); });
      ta.addEventListener('input', function () {
        var s = state[side]; s.type = 'sentence'; s.text = ta.value; s.zKey = ''; s.zIcon = ''; s.zLabel = '';
        if (cc) cc.textContent = ta.value.length;
        $all('[data-zodiac-side="' + side + '"]', root).forEach(function (z) { z.setAttribute('aria-pressed', 'false'); });
        open = side; syncHolder(side); syncOverlay(side); renderZoom(side, s);
      });
    });

    // per-side zodiac (replaces that side's text)
    $all('[data-zodiac-side]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var side = b.getAttribute('data-zodiac-side'), s = state[side];
        if (s.type === 'zodiac' && s.zKey === b.getAttribute('data-key')) { s.type = ''; s.zKey = ''; s.zIcon = ''; s.zLabel = ''; }
        else { s.type = 'zodiac'; s.zKey = b.getAttribute('data-key'); s.zIcon = b.getAttribute('data-icon'); s.zLabel = b.getAttribute('data-zodiac'); var ta = root.querySelector('[data-engrave-directtext="' + side + '"]'); if (ta) ta.value = ''; }
        $all('[data-zodiac-side="' + side + '"]', root).forEach(function (z) { z.setAttribute('aria-pressed', s.type === 'zodiac' && z.getAttribute('data-key') === s.zKey); });
        open = side; syncHolder(side); syncOverlay(side); renderZoom(side, s);
      });
    });

    // font applies to BOTH sides
    $all('[data-font]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-font'); state.Front.font = f; state.Back.font = f;
        $all('[data-font]', root).forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-font') === f); });
        syncHolder('Front'); syncHolder('Back'); syncOverlay('Front'); syncOverlay('Back');
        if (open) renderZoom(open, state[open]);
      });
    });

    // initial: Front tier active (paid). In free mode (For The One) there are no tiers — show BOTH boxes.
    open = 'Front';
    if (tierBtns.length) { setTier('Front'); }
    else { if (frontBox) frontBox.hidden = false; if (backBox) backBox.hidden = false; render(); }

    /* Engraving colour selector (Gold / White-Clear): swap example images + re-tint the preview */
    var colorHidden = root.querySelector('[data-engrave-color]');
    var exampleImgs = $all('[data-example-side]', root);
    function applyColorUI() {
      $all('[data-engrave-color-btn]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-engrave-color-btn') === engColor); });
      exampleImgs.forEach(function (img) { var src = img.getAttribute(engColor === 'white' ? 'data-src-white' : 'data-src-gold'); if (src) img.setAttribute('src', src); });
      if (colorHidden) colorHidden.value = engColor;
      if (open) renderZoom(open, state[open]);
      syncOverlay('Front'); syncOverlay('Back');
    }
    $all('[data-engrave-color-btn]', root).forEach(function (btn) {
      btn.addEventListener('click', function () { engColor = btn.getAttribute('data-engrave-color-btn'); applyColorUI(); });
    });
    applyColorUI();

    /* Floral border design number (1–18) */
    var floralHidden = root.querySelector('[data-engrave-floral]');
    var floralInput = root.querySelector('[data-engrave-floral-input]');
    if (floralInput) floralInput.addEventListener('input', function () {
      var digits = floralInput.value.replace(/[^0-9]/g, '');
      var v = parseInt(digits, 10);
      if (isNaN(v) || v < 1) { floralInput.value = digits; if (floralHidden) floralHidden.value = ''; return; }
      if (v > 18) v = 18;
      floralInput.value = String(v);
      if (floralHidden) floralHidden.value = String(v);
    });

    /* Floral catalog lightbox (click a sheet to enlarge) */
    var lightbox = root.querySelector('[data-engrave-lightbox]');
    var lightboxImg = root.querySelector('[data-lightbox-img]');
    $all('[data-floral-enlarge]', root).forEach(function (btn) {
      btn.addEventListener('click', function () { if (lightbox && lightboxImg) { lightboxImg.setAttribute('src', btn.getAttribute('data-floral-enlarge')); lightbox.hidden = false; } });
    });
    if (lightbox) {
      var lbClose = root.querySelector('[data-lightbox-close]');
      if (lbClose) lbClose.addEventListener('click', function () { lightbox.hidden = true; });
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) lightbox.hidden = true; });
    }

    render();
  }
  $all('[data-engrave-root]').forEach(initEngravingRoot);

  /* ---------- product reviews (display + submit via the Thetis Reviews Worker; data stored as Shopify metaobjects) ---------- */
  function initReviews(root) {
    var handle = root.getAttribute('data-product') || '';
    var api = root.getAttribute('data-reviews-api');
    var listEl = root.querySelector('[data-review-list]');
    var summaryEl = root.querySelector('[data-review-summary]');
    var emptyEl = root.querySelector('[data-review-empty]');

    // star rating for the write-a-review form (updates the hidden contact[Rating] field)
    var stars = root.querySelectorAll('[data-review-stars] [data-star]');
    var ratingInput = root.querySelector('[data-review-rating]');
    var rating = 5;
    function paintStars() {
      stars.forEach(function (s) { s.style.color = parseInt(s.getAttribute('data-star'), 10) <= rating ? '#B08D57' : '#C9C4B8'; });
      if (ratingInput) ratingInput.value = rating;
    }
    stars.forEach(function (s) { s.addEventListener('click', function () { rating = parseInt(s.getAttribute('data-star'), 10); paintStars(); }); });
    if (stars.length) paintStars();

    function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : String(s)); return d.innerHTML; }

    function render(reviews) {
      reviews = reviews || [];
      if (!reviews.length) { if (emptyEl) emptyEl.hidden = false; if (summaryEl) summaryEl.hidden = true; return; }
      if (emptyEl) emptyEl.hidden = true;
      var total = 0; reviews.forEach(function (r) { total += (parseInt(r.rating, 10) || 5); });
      var avg = total / reviews.length;
      if (summaryEl) {
        var full = Math.round(avg), sh = '';
        for (var i = 1; i <= 5; i++) sh += '<span style="color:' + (i <= full ? '#B08D57' : '#C9C4B8') + '">★</span>';
        summaryEl.hidden = false;
        summaryEl.innerHTML = '<span style="display:flex;gap:2px;font-size:18px">' + sh + '</span><span>' + avg.toFixed(1) + ' · ' + reviews.length + (reviews.length === 1 ? ' review' : ' reviews') + '</span>';
      }
      reviews.forEach(function (r) {
        var rt = parseInt(r.rating, 10) || 5;
        var hasPhoto = !!r.photo;
        var row = document.createElement('div');
        row.style.cssText = 'display:grid;grid-template-columns:' + (hasPhoto ? '100px 1fr' : '1fr') + ';gap:20px;padding-bottom:28px;border-bottom:1px solid #E4DFD3';
        var s = ''; for (var i = 1; i <= 5; i++) s += '<span style="font-size:14px;color:' + (i <= rt ? '#B08D57' : '#C9C4B8') + '">★</span>';
        var photoHtml = hasPhoto ? '<img src="' + esc(r.photo) + '" alt="" style="width:100px;height:100px;object-fit:cover;border-radius:4px">' : '';
        var dateHtml = r.date ? '<div style="font-size:12px;color:#8a8072;margin-top:2px">' + esc(r.date) + '</div>' : '';
        row.innerHTML = photoHtml +
          '<div><div style="display:flex;gap:2px;margin-bottom:6px">' + s + '</div>' +
          '<div style="font-size:14px;font-weight:500;color:#2b2620">' + esc(r.name) + '</div>' + dateHtml +
          '<div style="font-size:14px;color:#5c5346;line-height:1.7;margin-top:6px">' + esc(r.body || r.text || '') + '</div></div>';
        listEl.appendChild(row);
      });
    }

    // write-a-review form: POST to the Worker /submit (stored as "pending")
    var form = root.querySelector('[data-review-form]');
    if (form && api) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var errEl = root.querySelector('[data-review-error]');
        var thanksEl = root.querySelector('[data-review-thanks]');
        var fieldsEl = root.querySelector('[data-review-fields]');
        var btn = root.querySelector('[data-review-submit]');
        var nameV = ((form.querySelector('[name=name]') || {}).value || '').trim();
        var bodyV = ((form.querySelector('[name=body]') || {}).value || '').trim();
        var website = (form.querySelector('[name=website]') || {}).value || '';
        function fail(msg) { if (errEl) { errEl.hidden = false; errEl.textContent = msg; } if (btn) { btn.disabled = false; btn.textContent = 'Submit Review'; } }
        if (!nameV || !bodyV) { fail('Please add your name and a review.'); return; }
        if (errEl) errEl.hidden = true;
        if (btn) { btn.disabled = true; btn.textContent = 'Submitting…'; }
        fetch(api + '/submit', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ handle: handle, name: nameV, rating: rating, body: bodyV, website: website })
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && res.ok) { if (fieldsEl) fieldsEl.hidden = true; if (thanksEl) thanksEl.hidden = false; setTimeout(load, 300); }
          else fail('Sorry, something went wrong. Please try again.');
        }).catch(function () { fail('Sorry, something went wrong. Please try again.'); });
      });
    }

    // load reviews from the Worker (clears + re-renders; called on init and right after a post)
    function load() {
      if (!api) { render([]); return; }
      if (listEl) listEl.innerHTML = '';
      if (summaryEl) summaryEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      fetch(api + '/list?handle=' + encodeURIComponent(handle), { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (data) { render((data && data.reviews) || []); })
        .catch(function () { render([]); });
    }
    load();
  }
  $all('[data-reviews]').forEach(initReviews);

  /* ---------- search RESULTS page: re-render from the same client index (so Enter matches notes/inspired-by too) ---------- */
  function renderSearchPage() {
    var page = $('[data-search-page]');
    if (!page) return;
    var grid = page.querySelector('[data-search-page-results]');
    var empty = page.querySelector('[data-search-page-empty]');
    var countEl = page.querySelector('[data-search-page-count]');
    if (!grid) return;
    var params = new URLSearchParams(window.location.search);
    var q = (params.get('q') || page.getAttribute('data-q') || '').trim();
    if (!q) return;
    var idx = getSearchIndex();
    if (!idx || !idx.length) return; // keep the server-rendered fallback if the index is unavailable
    var terms = q.toLowerCase().split(/\s+/).filter(Boolean);
    var matches = idx.filter(function (p) { return terms.every(function (t) { return p.s.indexOf(t) !== -1; }); });
    if (countEl) countEl.textContent = 'Results for “' + q + '” · ' + matches.length;
    if (!matches.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    grid.innerHTML = matches.map(function (p) {
      var img = p.i ? '<img src="' + p.i + '" width="160" height="160" style="object-fit:contain;background:#fff" alt="">' : '';
      var insp = p.b ? '<div class="thetis-italic" style="font-size:12px">Inspired by ' + escapeHtml(p.b) + '</div>' : '';
      return '<article class="scent-card"><a class="scent-card__media" href="' + p.u + '">' + img + '</a>' +
        '<div class="scent-card__body"><a href="' + p.u + '"><span class="thetis-h3">' + escapeHtml(p.t) + '</span></a>' +
        insp + '<div class="scent-card__meta">' + escapeHtml(p.p) + '</div></div></article>';
    }).join('');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderSearchPage);
  else renderSearchPage();

  /* video[data-loop-end]: loop back to 0 at a set time (design uses this to trim a long clip, e.g. home signature strip) */
  function bindLoopEnds() {
    $all('video[data-loop-end]').forEach(function (v) {
      if (v._loopBound) return; v._loopBound = true;
      var end = parseFloat(v.getAttribute('data-loop-end'));
      if (!end) return;
      v.addEventListener('timeupdate', function () { if (v.currentTime >= end) { v.currentTime = 0; v.play().catch(function () {}); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindLoopEnds);
  else bindLoopEnds();
})();
